import type { FaireProductEntity } from "../../entity_types/product";

export const p_9smc22apga: FaireProductEntity = {
  token: "p_9smc22apga",
  type: "product",
  name: "santa bag christmas mini enclosure notecard",
  brandToken: "b_mmdanrh9jf",
  brandName: "emily lex studio",
  imageUrl:
    "https://cdn.faire.com/fastly/7a9d6ccd5bf3bdc1e3b3578f46f84d67f569ec58909a88b6b91c42de346a79b1.jpeg",
  galleryImageUrls: [],
  priceDollars: 3,
  description:
    'A mini notecard for petite greetings. Perfect for adding to a gift or popping in a gift card for a pretty (and easy!) presentation. \n\n\nDetails:\n\n- single card + envelope\n- blank inside\n- 2.5" x 3.5"\n- Printed on 120lb superfine paper\n- Original watercolor artwork by Emily Lex\n',
  tags: [],
  msrpDollars: 6,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-28T05:30:11.831Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
